export enum HeadlineEnum {
  Default = '0',
  PendingStart = '10',
  NoBillNewAcct = '20',
  SONPCompletedPastDue = '25',
  SONPCompletedNoPastDue = '26',
  SelectedForDisc = '30',
  AtRiskDisc = '50',
  IsZeroCredBal = '60',
  StoppedBadDebt = '110',
  StoppedPastDue = '120',
  StoppedNoPastDue = '130',
  ClosedButWithinSameSession = '150',
  ClosedSeasonalResSMCom = 'ClosedSeasonalResSMCom',
  ClosedSeasonalLargeCom = 'ClosedSeasonalLargeCom',
  ClosedNotSeasonalResSMComReconnect = 'ClosedNotSeasonalResSMComReconnect',
  ClosedNotSeasonalResSMComNoReconnect = 'ClosedNotSeasonalResSMComNoReconnect',
  ClosedNotSeasonalLargeCom = 'ClosedNotSeasonalLargeCom',
}
